import { useContext } from "react";
import { DynamicFormFullContext } from "../Providers/DynamicFormFullContextProvider";
import { IDynamicFormFullContext, IDynamicFormState } from "../DynamicFormContracts";

export default function useDynamicFormState<T = any>(fieldsNames?: (keyof T)[]): IDynamicFormState<T> {
  const context: IDynamicFormFullContext<T> = useContext(DynamicFormFullContext);
  if (!context) throw new Error("useDynamicFormValue should be used inside Dynamic Form");
  return context.state;
}
